import { useMemo } from 'react'

import { useAvatarSkins } from '@store'

export const useAvatarById = ({ avatarId }: { avatarId: string }) => {
  const avatars = useAvatarSkins()

  const avatar = useMemo(() => {
    return avatars.find((avatar) => avatar.id === avatarId)
  }, [avatarId, avatars])

  return { avatar }
}
